export default "__VITE_ASSET__d4de286d__"